<template>
  <w-main-template :showContentTitle="false" onselectstart="return false">
    <w-map-list slot="sideContent" :class="$style['side-h']" ref="mapList"></w-map-list>
    <w-topologymap-panel slot="mainContent" ref="topologymapPanel"></w-topologymap-panel>
  </w-main-template>
</template>

<script>

import WMainTemplate from '@/components/template/MainTemplate';

import WMapList from '@/views/topologymap/components/MapList';
import WTopologymapPanel from '@/views/topologymap/layout/TopologymapPanel';

export default {
  name: 'WTopologymap',
  components: {
    WMainTemplate,
    WMapList,
    WTopologymapPanel,
  },
};
</script>

<style module>
.side-h {
  height: calc(100% - 82px - 40px) /* 100% - title - header */
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/index.vue